// © Microsoft Corporation. All rights reserved.

/**
 * Constants used for Prime Integration
 */
export const PrimeIntegrationConstants = {

    /**
     * Default value we use for the name of the cookie that holds the ANID
     */
    AnonCookieName: "APP_ANON",

    /** The ID of the coachmark to show for when a user performed follow/unfollow action fails */
    userActionErrorCoachMarkId: "cm-spafeedsapp-user-action-error"
};
